import React from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  IconButton,
  Grid,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { Clear } from "@material-ui/icons";

type Props = {
  isOpen: boolean;
  handleClose: any;
  children?: any;
  heading?: any;
  maxWidth: "xs" | "sm" | "md" | "lg" | "xl" | undefined;
};
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});
export default function CommonDialog({
  isOpen,
  handleClose,
  children,
  heading,
  maxWidth,
}: Props): React.ReactElement {
  return (
    <>
      <Dialog
        style={{ borderRadius: 1, minWidth: "40%" }}
        open={isOpen}
        onClose={handleClose}
        TransitionComponent={Transition}
        keepMounted
        maxWidth={maxWidth}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <Typography>
          <DialogTitle id="alert-dialog-slide-title">
            <Grid container direction="row">
              <Grid item xs={11}>
                {heading}
              </Grid>
              <Grid item xs={1} style={{ position: "absolute", top: "0", right: "20px" }}>
                <IconButton onClick={handleClose}>
                  <Clear />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
        </Typography>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </>
  );
}
